import { createAsyncThunk } from '@reduxjs/toolkit'
import Subtitles from './subtitles-model'
import {
  delete_subtitles,
  load_subtitless,
  store_subtitles,
} from './subtitles-service'

export const LoadSubtitlessAsync = createAsyncThunk<any, any>(
  'composer/load/subtitles',
  async (params: { uid: string }) => {
    return await load_subtitless(params)
  },
)

export const CreateSubtitlesAsync = createAsyncThunk<any, any>(
  'composer/create/subtitles',
  async (params: Subtitles) => {
    return await store_subtitles(params)
  },
)

export const DeleteSubtitlesAsync = createAsyncThunk<any, any>(
  'composer/delete/subtitles',
  async (params) => {
    return await delete_subtitles(params)
  },
)
